// extracted by mini-css-extract-plugin
module.exports = {"likeButton":"LikeButton_likeButton__Sntmf","likeButtonInverted":"LikeButton_likeButtonInverted__QcY1B","likeButtonIcon":"LikeButton_likeButtonIcon__zb77g"};